export const BusinessTypeIndustries = {
  Agriculture: 'agriculture',
  Energy: 'energy',
  Construction: 'construction',
  Business: 'business',
  Technical: 'technical',
  Education: 'education',
  Healthcare: 'healthcare',
  Finance: 'finance',
  Safety: 'safety',
  Transportation: 'transportation',
  MotorVehicle: 'motor_vehicle',
  Manufacturing: 'manufacturing',
  RealEstate: 'real_estate',
  Wholesale: 'wholesale',
  Hospitality: 'hospitality'
  // Entertainment: 'entertainment',
  // Retail: 'retail',
  // PersonalServices: 'personal_services',
  // Other: 'other'
};

export const BusinessTypeIndustriesDisplayNames = {
  [BusinessTypeIndustries.Agriculture]: 'Agriculture & Forestry',
  [BusinessTypeIndustries.Energy]: 'Energy & Natural Resources',
  [BusinessTypeIndustries.Construction]: 'Construction',
  [BusinessTypeIndustries.Business]: 'Business & Information',
  [BusinessTypeIndustries.Technical]: 'Professional, Scientific, & Technical Services',
  [BusinessTypeIndustries.Education]: 'Education',
  [BusinessTypeIndustries.Healthcare]: 'Healthcare & Social Assistance',
  [BusinessTypeIndustries.Finance]: 'Finance & Insurance',
  [BusinessTypeIndustries.Safety]: 'Safety & Security',
  [BusinessTypeIndustries.Transportation]: 'Transportation',
  [BusinessTypeIndustries.MotorVehicle]: 'Motor Vehicle',
  [BusinessTypeIndustries.Manufacturing]: 'Manufacturing',
  [BusinessTypeIndustries.RealEstate]: 'Real Estate, Rental, & Leasing',
  [BusinessTypeIndustries.Wholesale]: 'Wholesale Trade',
  [BusinessTypeIndustries.Hospitality]: 'Food & Hospitality'
  // [BusinessTypeIndustries.Entertainment]: 'Arts, Entertainment, & Recreation',
  // [BusinessTypeIndustries.Retail]: 'Retail Trade',
  // [BusinessTypeIndustries.PersonalServices]: 'Personal Services',
  // [BusinessTypeIndustries.Other]: 'Other'
};

export const BusinessTypes = {
  Extermination: 'extermination',
  AnimalFarming: 'animal_farming',
  CropFarming: 'crop_farming',
  FoodProcessing: 'food_processing',
  FishingAndHunting: 'fishing_and_hunting',
  Forestry: 'forestry',
  Landscape: 'landscape',
  LawnCare: 'lawn_care',
  OtherAgriculture: 'other_agriculture',
  OilDistribution: 'oil_distribution',
  OilProduction: 'oil_production',
  Mining: 'mining',
  Pipeline: 'pipeline',
  WaterWellDrilling: 'water_well_drilling',
  AlternativeEnergy: 'alternative_energy',
  ElectricUtilities: 'electric_utilities',
  WasteManagement: 'waste_management',
  Conservation: 'conservation',
  EnvironmentalHealth: 'environmental_health',
  LandSurveying: 'land_surveying',
  OtherEnergy: 'other_energy',
  ArchitecturalEngineering: 'architectural_engineering',
  HomeBuilders: 'home_builders',
  GeneralContractors: 'general_contractors',
  SpecialtyContractorStructure: 'specialty_contractor_structure',
  SpecialtyContractorEquipment: 'specialty_contractor_equipment',
  SpecialtyContractorFinishing: 'specialty_contractor_finishing',
  SpecialtyContractorOther: 'specialty_contractor_other',
  BuildingMaterials: 'building_materials',
  EquipmentRental: 'equipment_rental',
  HVAC: 'hvac',
  Plumbing: 'plumbing',
  RepairMaintenance: 'repair_maintenance',
  OtherConstruction: 'other_construction',
  JanitorialServices: 'janitorial_services',
  EmploymentServices: 'employment_services',
  BusinessSupportServices: 'business_support_services',
  OfficeAdministrativeServices: 'office_administrative_services',
  FacilitiesSupportServices: 'facilities_support_services',
  Fundraisers: 'fundraisers',
  Marketing: 'marketing',
  PublicRelations: 'public_relations',
  Broadcasting: 'broadcasting',
  MotionPictureProduction: 'motion_picture_production',
  SoundRecording: 'sound_recording',
  TVProduction: 'tv_production',
  NonProfit: 'non_profit',
  NotaryPublic: 'notary_public',
  OnlineBusiness: 'online_business',
  PrintingServices: 'printing_services',
  RecordBusiness: 'record_business',
  RetailSales: 'retail_sales',
  TechnologyServices: 'technology_services',
  Telemarketing: 'telemarketing',
  Telecommunications: 'telecommunications',
  DataProcessingAndHosting: 'data_processing_and_hosting',
  TravelServices: 'travel_services',
  VideoProduction: 'video_production',
  ReligiousOrganizations: 'religious_organization',
  OtherBusiness: 'other_business',
  LegalServices: 'legal_services',
  AccountingServices: 'accounting_services',
  BookkeepingServices: 'bookkeeping_services',
  ManagementConsultingServices: 'management_consulting_services',
  ScientificConsultingServices: 'scientific_consulting_services',
  TechnicalConsultingServices: 'technical_consulting_services',
  ScientificResearchDevelopment: 'scientific_research_development',
  CompanyManagement: 'company_management',
  SpecializedDesignServices: 'specialized_design_services',
  ComputerSystemsDesign: 'computer_systems_design',
  OtherTechnical: 'other_technical',
  ChildCare: 'child_care',
  CollegesAndUniversities: 'colleges_and_universities',
  JuniorColleges: 'junior_colleges',
  ElementaryAndSecondaryEducation: 'elementary_and_secondary_education',
  BusinessSchools: 'business_schools',
  ComputerTraining: 'computer_training',
  TechnicalAndTradeSchools: 'technical_and_trade_schools',
  Tutoring: 'tutoring',
  VocationalSchool: 'vocational_school',
  CosmetologySchool: 'cosmetology_school',
  PrivateSchools: 'private_schools',
  OtherEducation: 'other_education',
  AmbulatoryServices: 'ambulatory_services',
  EmergencyMedicalServices: 'emergency_medical_services',
  EmergencyMedicalTransportation: 'emergency_medical_transportation',
  NonEmergencyMedicalTransportation: 'non_emergency_medical_transportation',
  Hospitals: 'hospitals',
  NursingFacilities: 'nursing_facilities',
  HomeHealthServices: 'home_health_services',
  SocialAssistance: 'social_assistance',
  MentalHealthServices: 'mental_health_services',
  Acupuncturist: 'acupuncturist',
  AthleticTraining: 'athletic_training',
  YouthServices: 'youth_services',
  Chiropractic: 'chiropractic',
  Dentistry: 'dentistry',
  Electrolysis: 'electrolysis',
  Embalmer: 'embalmer',
  HearingAidDealers: 'hearing_aid_dealers',
  MassageTherapy: 'massage_therapy',
  MedicalOffice: 'medical_office',
  Optometry: 'optometry',
  Pharmacy: 'pharmacy',
  PhysicalTherapy: 'physical_therapy',
  PhysiciansOffice: 'physicians_office',
  Radiology: 'radiology',
  OccupationalTherapy: 'occupational_therapy',
  SubstanceAbuseServices: 'substance_abuse_services',
  VeterinaryMedicine: 'veterinary_medicine',
  VocationalRehabilitation: 'vocational_rehabilitation',
  WholesaleDrugDistribution: 'wholesale_drug_distribution',
  MedicalSupplies: 'medical_supplies',
  HealthProfessionals: 'health_professionals',
  OtherHealthcare: 'other_healthcare',
  Auditing: 'auditing',
  BankCreditUnion: 'bank_credit_union',
  CashAdvances: 'cash_advances',
  CollectionAgency: 'collection_agency',
  InsuranceCarriers: 'insurance_carriers',
  CreditIntermediation: 'credit_intermediation',
  FinancialVehicles: 'financial_vehicles',
  FinancialInvestments: 'financial_investments',
  Investor: 'investor',
  PawnBrokers: 'pawn_brokers',
  OtherFinance: 'other_finance',
  BailBonds: 'bail_bonds',
  DrugScreening: 'drug_screening',
  Locksmith: 'locksmith',
  PrivateInvestigator: 'private_investigator',
  SecurityGaurd: 'security_guard',
  SecuritySystemServices: 'security_system_services',
  DefenseAerospace: 'defense_aerospace',
  DefenseElectronics: 'defense_electronics',
  OtherSafety: 'other_safety',
  AviationTransportation: 'aviation_transportation',
  BoatServices: 'boat_services',
  SeaTransport: 'sea_transport',
  WaterTransportation: 'water_transportation',
  GroundPassengerTransportation: 'ground_passenger_transportation',
  PipelineTransportation: 'pipeline_transportation',
  LimousineServices: 'limousine_services',
  TaxiServices: 'taxi_services',
  TowingServices: 'towing_services',
  TruckTransportationFuel: 'truck_transportation_fuel',
  TruckTransportation: 'truck_transportation',
  RailTransportation: 'rail_transportation',
  SightseeingTransportation: 'sightseeing_transportation',
  Couriers: 'couriers',
  Storage: 'storage',
  OtherTransportation: 'other_transportation',
  AutoPartSales: 'auto_part_sales',
  CarWash: 'car_wash',
  MotorVehicleRental: 'motor_vehicle_rental',
  MotorVehicleRepair: 'motor_vehicle_repair',
  NewMotorVehicleSales: 'new_motor_vehicle_sales',
  RecreationalVehicleSales: 'recreational_vehicle_sales',
  UsedMotorVehicleSales: 'used_motor_vehicle_sales',
  OtherMotorVehicle: 'other_motor_vehicle',
  FoodManufacturing: 'food_manufacturing',
  BeverageManufacturing: 'beverage_manufacturing',
  TobaccaoManufacturing: 'tobacco_manufacturing',
  TextileMills: 'textile_mills',
  TextileProductMills: 'textile_product_mills',
  ApparelManufacturing: 'apparel_manufacturing',
  LeatherManufacturing: 'leather_manufacturing',
  WoodProductManufacturing: 'wood_product_manufacturing',
  PaperManufacturing: 'paper_manufacturing',
  CoalProductsManufacturing: 'coal_products_manufacturing',
  ChemicalManufacturing: 'chemical_manufacturing',
  PlasticsManufacturing: 'plastics_manufacturing',
  NonmetallicMineralProductsManufacturing: 'nonmetallic_mineral_products_manufacturing',
  PrimaryMetalManufacturing: 'primary_metal_manufacturing',
  FabricatedMetalManufacturing: 'fabricated_metal_manufacturing',
  MachineryManufacturing: 'machinery_manufacturing',
  ElectronicProductManufacturing: 'electronic_product_manufacturing',
  ElectricalManufacturing: 'electrical_manufacturing',
  TransportationManufacturing: 'transportation_manufacturing',
  FurnitureManufacturing: 'furniture_manufacturing',
  MiscManufacturing: 'misc_manufacturing',
  PropertyManagement: 'property_management',
  RealEstateBrokerAgent: 'real_estate_broker_agent',
  Warehouse: 'warehouse',
  AutomotiveEquipmentRental: 'automotive_equipment_rental',
  ConsumerGoodsRental: 'consumer_goods_rental',
  GeneralRentalCenters: 'general_rental_centers',
  CommercialIndustrialMachineryRental: 'commercial_industrial_machinery_rental',
  Leasing: 'leasing',
  OtherRealEstate: 'other_real_estate',
  WholesaleDurableGoods: 'wholesale_durable_goods',
  WholesaleNonDurableGoods: 'wholesale_non_durable_goods',
  LodgingTourism: 'lodging_tourism',
  AlcoholTobaccoSales: 'alcohol_tobacco_sales',
  AlcoholicBeverageManufacturing: 'alcoholic_beverage_mfg',
  TobaccoProductManufacturing: 'tobacco_product_mfg',
  Bakery: 'bakery',
  Catering: 'catering',
  FoodBeverageManufacturing: 'food_beverage_mfg',
  GasStationStore: 'gas_station_store',
  GroceryConvenienceStore: 'grocery_convenience_store',
  TruckStop: 'truck_stop',
  VendingMachine: 'vending_machine',
  MobileFoodService: 'mobile_food_service',
  BarRestuarant: 'bar_restuarant',
  SpecialFoodServices: 'special_food_services',
  Produce: 'produce',
  Meat: 'meat',
  Seafood: 'seafood',
  Casino: 'casino',
  HotelsMotels: 'hotels_motels',
  TravelerAccommodations: 'traveler_accommodations',
  RVParks: 'rv_parks',
  BoardingHouses: 'boarding_houses',
  ShortTermRental: 'short_term_rentals',
  OtherHospitality: 'other_hospitality'
};

export const BusinessTypesDisplayNames = {
  [BusinessTypes.Extermination]: 'Extermination & Pest Control',
  [BusinessTypes.AnimalFarming]: 'Farming (Animal Production)',
  [BusinessTypes.CropFarming]: 'Farming (Crop Production)',
  [BusinessTypes.FoodProcessing]: 'Food Processing & Sales',
  [BusinessTypes.FishingAndHunting]: 'Fishing, Hunting, & Trapping',
  [BusinessTypes.Forestry]: 'Forestry & Logging',
  [BusinessTypes.Landscape]: 'Landscape Services',
  [BusinessTypes.LawnCare]: 'Lawn Care Services',
  [BusinessTypes.OtherAgriculture]: 'Other (Agriculture & Forestry)',
  [BusinessTypes.OilDistribution]: 'Oil & Gas Distribution',
  [BusinessTypes.OilProduction]: 'Oil & Gas Production',
  [BusinessTypes.Mining]: 'Mining',
  [BusinessTypes.Pipeline]: 'Pipeline',
  [BusinessTypes.WaterWellDrilling]: 'Water Well Drilling',
  [BusinessTypes.AlternativeEnergy]: 'Alternative Energy Production & Services',
  [BusinessTypes.ElectricUtilities]: 'Electric Utilities',
  [BusinessTypes.WasteManagement]: 'Waste Management',
  [BusinessTypes.Conservation]: 'Conservation',
  [BusinessTypes.EnvironmentalHealth]: 'Environmental Health',
  [BusinessTypes.LandSurveying]: 'Land Surveying',
  [BusinessTypes.OtherEnergy]: 'Other (Energy & Natural Resources)',
  [BusinessTypes.ArchitecturalEngineering]: 'Architectural & Engineering Services',
  [BusinessTypes.HomeBuilders]: 'Home Builders',
  [BusinessTypes.GeneralContractors]: 'General Contractors',
  [BusinessTypes.SpecialtyContractorStructure]: 'Specialty Contractor - Foundation, Structure, Building Exterior',
  [BusinessTypes.SpecialtyContractorEquipment]: 'Specialty Contractor - Building Equipment',
  [BusinessTypes.SpecialtyContractorFinishing]: 'Specialty Contractor - Building Finishing',
  [BusinessTypes.SpecialtyContractorOther]: 'Specialty Contractor - Other',
  [BusinessTypes.BuildingMaterials]: 'Building Materials',
  [BusinessTypes.EquipmentRental]: 'Equipment Rental',
  [BusinessTypes.HVAC]: 'AC & Heating (HVAC)',
  [BusinessTypes.Plumbing]: 'Plumbing',
  [BusinessTypes.RepairMaintenance]: 'Repair & Maintenance',
  [BusinessTypes.OtherConstruction]: 'Other (Construction)',
  [BusinessTypes.JanitorialServices]: 'Janitorial & Cleaning Services',
  [BusinessTypes.EmploymentServices]: 'Employment Services',
  [BusinessTypes.BusinessSupportServices]: 'Business Support Services',
  [BusinessTypes.OfficeAdministrativeServices]: 'Office Administrative Services',
  [BusinessTypes.FacilitiesSupportServices]: 'Facilities Support Services',
  [BusinessTypes.Fundraisers]: 'Fundraisers',
  [BusinessTypes.Marketing]: 'Marketing & Advertising',
  [BusinessTypes.PublicRelations]: 'Public Relations',
  [BusinessTypes.Broadcasting]: 'Broadcasting',
  [BusinessTypes.MotionPictureProduction]: 'Motion Picture Production',
  [BusinessTypes.SoundRecording]: 'Sound Recording & Music Production',
  [BusinessTypes.TVProduction]: 'TV Production',
  [BusinessTypes.NonProfit]: 'Non-Profit Organization',
  [BusinessTypes.NotaryPublic]: 'Notary Public',
  [BusinessTypes.OnlineBusiness]: 'Online Business',
  [BusinessTypes.PrintingServices]: 'Printing & Publishing Services',
  [BusinessTypes.RecordBusiness]: 'Record Business',
  [BusinessTypes.RetailSales]: 'Retail Sales',
  [BusinessTypes.TechnologyServices]: 'Technology Services',
  [BusinessTypes.Telemarketing]: 'Telemarketing',
  [BusinessTypes.Telecommunications]: 'Telecommunications',
  [BusinessTypes.DataProcessingAndHosting]: 'Data Processing, Hosting, & Related Services',
  [BusinessTypes.TravelServices]: 'Travel Arrangement & Reservation Services',
  [BusinessTypes.VideoProduction]: 'Video Production',
  [BusinessTypes.ReligiousOrganizations]: 'Clergy & Religious Organizations',
  [BusinessTypes.OtherBusiness]: 'Other (Business & Information Services)',
  [BusinessTypes.LegalServices]: 'Legal Services',
  [BusinessTypes.AccountingServices]: 'Accounting & Tax Preparation Services',
  [BusinessTypes.BookkeepingServices]: 'Bookkeeping & Payroll Services',
  [BusinessTypes.ManagementConsultingServices]: 'Management Consulting Services',
  [BusinessTypes.ScientificConsultingServices]: 'Scientific Consulting Services',
  [BusinessTypes.TechnicalConsultingServices]: 'Technical Consulting Services',
  [BusinessTypes.ScientificResearchDevelopment]: 'Scientific Research & Development',
  [BusinessTypes.CompanyManagement]: 'Company & Enterprise Management',
  [BusinessTypes.SpecializedDesignServices]: 'Specialized Design Services',
  [BusinessTypes.ComputerSystemsDesign]: 'Computer Systems Design and Related Services',
  [BusinessTypes.OtherTechnical]: 'Other (Professional, Scientific, & Technical Services)',
  [BusinessTypes.ChildCare]: 'Child Care',
  [BusinessTypes.CollegesAndUniversities]: 'Colleges & Universities',
  [BusinessTypes.JuniorColleges]: 'Junior Colleges',
  [BusinessTypes.ElementaryAndSecondaryEducation]: 'Elementary & Secondary Education',
  [BusinessTypes.BusinessSchools]: 'Business Schools',
  [BusinessTypes.ComputerTraining]: 'Computer Training',
  [BusinessTypes.TechnicalAndTradeSchools]: 'Technical & Trade Schools',
  [BusinessTypes.Tutoring]: 'Tutoring Services',
  [BusinessTypes.VocationalSchool]: 'Vocational School',
  [BusinessTypes.CosmetologySchool]: 'Cosmetology School',
  [BusinessTypes.PrivateSchools]: 'Private Schools',
  [BusinessTypes.OtherEducation]: 'Other (Education)',
  [BusinessTypes.AmbulatoryServices]: 'Ambulatory Services',
  [BusinessTypes.EmergencyMedicalServices]: 'Emergency Medical Services',
  [BusinessTypes.EmergencyMedicalTransportation]: 'Emergency Medical Transportation',
  [BusinessTypes.NonEmergencyMedicalTransportation]: 'Non-Emergency Medical Transportation',
  [BusinessTypes.Hospitals]: 'Hospitals',
  [BusinessTypes.NursingFacilities]: 'Nursing & Residential Facilities',
  [BusinessTypes.HomeHealthServices]: 'Home Health Services',
  [BusinessTypes.SocialAssistance]: 'Social Assistance',
  [BusinessTypes.MentalHealthServices]: 'Mental Health Services',
  [BusinessTypes.Acupuncturist]: 'Acupuncturist',
  [BusinessTypes.AthleticTraining]: 'Athletic Training',
  [BusinessTypes.YouthServices]: 'Youth Services',
  [BusinessTypes.Chiropractic]: 'Chiropractic',
  [BusinessTypes.Dentistry]: 'Dentistry',
  [BusinessTypes.Electrolysis]: 'Electrolysis',
  [BusinessTypes.Embalmer]: 'Embalmer',
  [BusinessTypes.HearingAidDealers]: 'Hearing Aid Dealers',
  [BusinessTypes.MassageTherapy]: 'Massage Therapy',
  [BusinessTypes.MedicalOffice]: 'Medical Office',
  [BusinessTypes.Optometry]: 'Optometry',
  [BusinessTypes.Pharmacy]: 'Pharmacy',
  [BusinessTypes.PhysicalTherapy]: 'Physical Therapy',
  [BusinessTypes.PhysiciansOffice]: 'Physicians Office',
  [BusinessTypes.Radiology]: 'Radiology',
  [BusinessTypes.OccupationalTherapy]: 'Occupational Therapy',
  [BusinessTypes.SubstanceAbuseServices]: 'Substance Abuse Services',
  [BusinessTypes.VeterinaryMedicine]: 'Veterinary Medicine',
  [BusinessTypes.VocationalRehabilitation]: 'Vocational Rehabilitation',
  [BusinessTypes.WholesaleDrugDistribution]: 'Wholesale Drug Distribution',
  [BusinessTypes.MedicalSupplies]: 'Medical Supplies',
  [BusinessTypes.HealthProfessionals]: 'Health Professionals',
  [BusinessTypes.OtherHealthcare]: 'Other (Healthcare & Social Assistance Services)',
  [BusinessTypes.Auditing]: 'Auditing Services',
  [BusinessTypes.BankCreditUnion]: 'Bank & Credit Union',
  [BusinessTypes.CashAdvances]: 'Cash Advances',
  [BusinessTypes.CollectionAgency]: 'Collection Agency',
  [BusinessTypes.InsuranceCarriers]: 'Insurance Carriers & Related Services',
  [BusinessTypes.CreditIntermediation]: 'Credit Intermediation & Related Services',
  [BusinessTypes.FinancialVehicles]: 'Funds, Trusts, & Other Financial Vehicles',
  [BusinessTypes.FinancialInvestments]: 'Securities, Commodity Contracts, & Other Financial Investments',
  [BusinessTypes.Investor]: 'Investor',
  [BusinessTypes.PawnBrokers]: 'Pawn Brokers',
  [BusinessTypes.OtherFinance]: 'Other (Finance & Insurance)',
  [BusinessTypes.BailBonds]: 'Bail Bonds',
  [BusinessTypes.DrugScreening]: 'Drug Screening',
  [BusinessTypes.Locksmith]: 'Locksmith',
  [BusinessTypes.PrivateInvestigator]: 'Private Investigator',
  [BusinessTypes.SecurityGaurd]: 'Security Guard',
  [BusinessTypes.SecuritySystemServices]: 'Security System Services',
  [BusinessTypes.DefenseAerospace]: 'Defense Aerospace',
  [BusinessTypes.DefenseElectronics]: 'Defense Electronics',
  [BusinessTypes.OtherSafety]: 'Other (Safety & Security Services)',
  [BusinessTypes.AviationTransportation]: 'Aviation & Air Transportation',
  [BusinessTypes.BoatServices]: 'Boat Services',
  [BusinessTypes.SeaTransport]: 'Sea Transport',
  [BusinessTypes.WaterTransportation]: 'Water Transportation',
  [BusinessTypes.GroundPassengerTransportation]: 'Transit & Ground Passenger Transportation',
  [BusinessTypes.PipelineTransportation]: 'Pipeline Transportation',
  [BusinessTypes.LimousineServices]: 'Limousine Services',
  [BusinessTypes.TaxiServices]: 'Taxi Services',
  [BusinessTypes.TowingServices]: 'Towing Services',
  [BusinessTypes.TruckTransportationFuel]: 'Truck Transportation (Fuel)',
  [BusinessTypes.TruckTransportation]: 'Truck Transportation (Non-Fuel)',
  [BusinessTypes.RailTransportation]: 'Rail Transportation',
  [BusinessTypes.SightseeingTransportation]: 'Sightseeing Transportation',
  [BusinessTypes.Couriers]: 'Couriers',
  [BusinessTypes.Storage]: 'Storage',
  [BusinessTypes.OtherTransportation]: 'Other (Transportation)',
  [BusinessTypes.AutoPartSales]: 'Auto Part Sales',
  [BusinessTypes.CarWash]: 'Car Wash & Detailing',
  [BusinessTypes.MotorVehicleRental]: 'Motor Vehicle Rental',
  [BusinessTypes.MotorVehicleRepair]: 'Motor Vehicle Repair',
  [BusinessTypes.NewMotorVehicleSales]: 'New Motor Vehicle Sales',
  [BusinessTypes.RecreationalVehicleSales]: 'Recreational Vehicle Sales',
  [BusinessTypes.UsedMotorVehicleSales]: 'Used Motor Vehicle Sales',
  [BusinessTypes.OtherMotorVehicle]: 'Other (Motor Vehicle)',
  [BusinessTypes.FoodManufacturing]: 'Food Manufacturing',
  [BusinessTypes.BeverageManufacturing]: 'Beverage Manufacturing',
  [BusinessTypes.TobaccaoManufacturing]: 'Tobacco Manufacturing',
  [BusinessTypes.TextileMills]: 'Textile Mills',
  [BusinessTypes.TextileProductMills]: 'Textile Product Mills',
  [BusinessTypes.ApparelManufacturing]: 'Apparel Manufacturing',
  [BusinessTypes.LeatherManufacturing]: 'Leather & Allied Product Manufacturing',
  [BusinessTypes.WoodProductManufacturing]: 'Wood Product Manufacturing',
  [BusinessTypes.PaperManufacturing]: 'Paper Manufacturing',
  [BusinessTypes.CoalProductsManufacturing]: 'Petroleum & Coal Products Manufacturing',
  [BusinessTypes.ChemicalManufacturing]: 'Chemical Manufacturing',
  [BusinessTypes.PlasticsManufacturing]: 'Plastics & Rubber Manufacturing',
  [BusinessTypes.NonmetallicMineralProductsManufacturing]: 'Nonmetallic Mineral Products Manufacturing',
  [BusinessTypes.PrimaryMetalManufacturing]: 'Primary Metal Manufacturing',
  [BusinessTypes.FabricatedMetalManufacturing]: 'Fabricated Metal Manufacturing',
  [BusinessTypes.MachineryManufacturing]: 'Machinery Manufacturing',
  [BusinessTypes.ElectronicProductManufacturing]: 'Computer & Electronic Product Manufacturing',
  [BusinessTypes.ElectricalManufacturing]: 'Electrical Equipment, Appliances, & Component Manufacturing',
  [BusinessTypes.TransportationManufacturing]: 'Transportation Manufacturing',
  [BusinessTypes.FurnitureManufacturing]: 'Furniture & Related Product Manufacturing',
  [BusinessTypes.MiscManufacturing]: 'Miscellaneous Manufacturing',
  [BusinessTypes.PropertyManagement]: 'Property Management',
  [BusinessTypes.RealEstateBrokerAgent]: 'Real Estate Broker/Agent',
  [BusinessTypes.Warehouse]: 'Warehouse/Storage',
  [BusinessTypes.AutomotiveEquipmentRental]: 'Automotive Equipment Rental & Leasing',
  [BusinessTypes.ConsumerGoodsRental]: 'Consumer Goods Rental',
  [BusinessTypes.GeneralRentalCenters]: 'General Rental Centers',
  [BusinessTypes.CommercialIndustrialMachineryRental]: 'Commercial & Industrial Machinery Rental',
  [BusinessTypes.Leasing]: 'Leasing',
  [BusinessTypes.OtherRealEstate]: 'Other (Real Estate, Rental, & Leasing)',
  [BusinessTypes.WholesaleDurableGoods]: 'Merchant Wholesalers - Durable Goods',
  [BusinessTypes.WholesaleNonDurableGoods]: 'Merchant Wholesalers - Non-Durable Goods',
  [BusinessTypes.LodgingTourism]: 'Lodging & Tourism',
  [BusinessTypes.AlcoholTobaccoSales]: 'Alcohol & Tobacco Sales',
  [BusinessTypes.AlcoholicBeverageManufacturing]: 'Alcoholic Beverage Manufacturing',
  [BusinessTypes.TobaccoProductManufacturing]: 'Tobacco Product Manufacturing',
  [BusinessTypes.Bakery]: 'Bakery',
  [BusinessTypes.Catering]: 'Catering',
  [BusinessTypes.FoodBeverageManufacturing]: 'Food & Beverage Manufacturing',
  [BusinessTypes.GasStationStore]: 'Gas Station & Convenience',
  [BusinessTypes.GroceryConvenienceStore]: 'Grocery/Convenience Store',
  [BusinessTypes.TruckStop]: 'Truck Stop',
  [BusinessTypes.VendingMachine]: 'Vending Machine',
  [BusinessTypes.MobileFoodService]: 'Mobile Food Service',
  [BusinessTypes.BarRestuarant]: 'Bar/Restuarant',
  [BusinessTypes.SpecialFoodServices]: 'Special Food Services',
  [BusinessTypes.Produce]: 'Specialty - Produce',
  [BusinessTypes.Meat]: 'Speciality - Meat',
  [BusinessTypes.Seafood]: 'Specialty - Seafood',
  [BusinessTypes.Casino]: 'Casino',
  [BusinessTypes.HotelsMotels]: 'Hotels & Motels',
  [BusinessTypes.TravelerAccommodations]: 'Traveler Accommodations',
  [BusinessTypes.RVParks]: 'RV Parks & Recreational Camps',
  [BusinessTypes.BoardingHouses]: 'Rooming & Boarding Houses',
  [BusinessTypes.ShortTermRental]: 'Short Term Rentals',
  [BusinessTypes.OtherHospitality]: 'Other (Food & Hospitality)'
};

export const BusinessTypesByIndustry = {
  [BusinessTypeIndustries.Agriculture]: [
    {
      value: BusinessTypes.Extermination,
      text: BusinessTypesDisplayNames[BusinessTypes.Extermination]
    },
    {
      value: BusinessTypes.AnimalFarming,
      text: BusinessTypesDisplayNames[BusinessTypes.AnimalFarming]
    },
    {
      value: BusinessTypes.CropFarming,
      text: BusinessTypesDisplayNames[BusinessTypes.CropFarming]
    },
    {
      value: BusinessTypes.FoodProcessing,
      text: BusinessTypesDisplayNames[BusinessTypes.FoodProcessing]
    },
    {
      value: BusinessTypes.FishingAndHunting,
      text: BusinessTypesDisplayNames[BusinessTypes.FishingAndHunting]
    },
    {
      value: BusinessTypes.Forestry,
      text: BusinessTypesDisplayNames[BusinessTypes.Forestry]
    },
    {
      value: BusinessTypes.Landscape,
      text: BusinessTypesDisplayNames[BusinessTypes.Landscape]
    },
    {
      value: BusinessTypes.LawnCare,
      text: BusinessTypesDisplayNames[BusinessTypes.LawnCare]
    },
    {
      value: BusinessTypes.OtherAgriculture,
      text: BusinessTypesDisplayNames[BusinessTypes.OtherAgriculture]
    }
  ],
  [BusinessTypeIndustries.Energy]: [
    {
      value: BusinessTypes.OilDistribution,
      text: BusinessTypesDisplayNames[BusinessTypes.OilDistribution]
    },
    {
      value: BusinessTypes.OilProduction,
      text: BusinessTypesDisplayNames[BusinessTypes.OilProduction]
    },
    {
      value: BusinessTypes.Mining,
      text: BusinessTypesDisplayNames[BusinessTypes.Mining]
    },
    {

      value: BusinessTypes.Pipeline,
      text: BusinessTypesDisplayNames[BusinessTypes.Pipeline]
    },
    {
      value: BusinessTypes.WaterWellDrilling,
      text: BusinessTypesDisplayNames[BusinessTypes.WaterWellDrilling]
    },
    {
      value: BusinessTypes.AlternativeEnergy,
      text: BusinessTypesDisplayNames[BusinessTypes.AlternativeEnergy]
    },
    {
      value: BusinessTypes.ElectricUtilities,
      text: BusinessTypesDisplayNames[BusinessTypes.ElectricUtilities]
    },
    {
      value: BusinessTypes.WasteManagement,
      text: BusinessTypesDisplayNames[BusinessTypes.WasteManagement]
    },
    {
      value: BusinessTypes.Conservation,
      text: BusinessTypesDisplayNames[BusinessTypes.Conservation]
    },
    {
      value: BusinessTypes.EnvironmentalHealth,
      text: BusinessTypesDisplayNames[BusinessTypes.EnvironmentalHealth]
    },
    {
      value: BusinessTypes.LandSurveying,
      text: BusinessTypesDisplayNames[BusinessTypes.LandSurveying]
    },
    {
      value: BusinessTypes.OtherEnergy,
      text: BusinessTypesDisplayNames[BusinessTypes.OtherEnergy]
    }
  ],
  [BusinessTypeIndustries.Construction]: [
    {
      value: BusinessTypes.ArchitecturalEngineering,
      text: BusinessTypesDisplayNames[BusinessTypes.ArchitecturalEngineering]
    },
    {
      value: BusinessTypes.HomeBuilders,
      text: BusinessTypesDisplayNames[BusinessTypes.HomeBuilders]
    },
    {
      value: BusinessTypes.GeneralContractors,
      text: BusinessTypesDisplayNames[BusinessTypes.GeneralContractors]
    },
    {
      value: BusinessTypes.SpecialtyContractorStructure,
      text: BusinessTypesDisplayNames[BusinessTypes.SpecialtyContractorStructure]
    },
    {
      value: BusinessTypes.SpecialtyContractorEquipment,
      text: BusinessTypesDisplayNames[BusinessTypes.SpecialtyContractorEquipment]
    },
    {
      value: BusinessTypes.SpecialtyContractorFinishing,
      text: BusinessTypesDisplayNames[BusinessTypes.SpecialtyContractorFinishing]
    },
    {
      value: BusinessTypes.SpecialtyContractorOther,
      text: BusinessTypesDisplayNames[BusinessTypes.SpecialtyContractorOther]
    },
    {
      value: BusinessTypes.BuildingMaterials,
      text: BusinessTypesDisplayNames[BusinessTypes.BuildingMaterials]
    },
    {
      value: BusinessTypes.EquipmentRental,
      text: BusinessTypesDisplayNames[BusinessTypes.EquipmentRental]
    },
    {
      value: BusinessTypes.HVAC,
      text: BusinessTypesDisplayNames[BusinessTypes.HVAC]
    },
    {
      value: BusinessTypes.Plumbing,
      text: BusinessTypesDisplayNames[BusinessTypes.Plumbing]
    },
    {
      value: BusinessTypes.RepairMaintenance,
      text: BusinessTypesDisplayNames[BusinessTypes.RepairMaintenance]
    },
    {
      value: BusinessTypes.OtherConstruction,
      text: BusinessTypesDisplayNames[BusinessTypes.OtherConstruction]
    }
  ],
  [BusinessTypeIndustries.Business]: [
    {
      value: BusinessTypes.JanitorialServices,
      text: BusinessTypesDisplayNames[BusinessTypes.JanitorialServices]
    },
    {
      value: BusinessTypes.EmploymentServices,
      text: BusinessTypesDisplayNames[BusinessTypes.EmploymentServices]
    },
    {
      value: BusinessTypes.BusinessSupportServices,
      text: BusinessTypesDisplayNames[BusinessTypes.BusinessSupportServices]
    },
    {
      value: BusinessTypes.OfficeAdministrativeServices,
      text: BusinessTypesDisplayNames[BusinessTypes.OfficeAdministrativeServices]
    },
    {
      value: BusinessTypes.FacilitiesSupportServices,
      text: BusinessTypesDisplayNames[BusinessTypes.FacilitiesSupportServices]
    },
    {
      value: BusinessTypes.Fundraisers,
      text: BusinessTypesDisplayNames[BusinessTypes.Fundraisers]
    },
    {
      value: BusinessTypes.Marketing,
      text: BusinessTypesDisplayNames[BusinessTypes.Marketing]
    },
    {
      value: BusinessTypes.PublicRelations,
      text: BusinessTypesDisplayNames[BusinessTypes.PublicRelations]
    },
    {
      value: BusinessTypes.Broadcasting,
      text: BusinessTypesDisplayNames[BusinessTypes.Broadcasting]
    },
    {
      value: BusinessTypes.MotionPictureProduction,
      text: BusinessTypesDisplayNames[BusinessTypes.MotionPictureProduction]
    },
    {
      value: BusinessTypes.SoundRecording,
      text: BusinessTypesDisplayNames[BusinessTypes.SoundRecording]
    },
    {
      value: BusinessTypes.TVProduction,
      text: BusinessTypesDisplayNames[BusinessTypes.TVProduction]
    },
    {
      value: BusinessTypes.NonProfit,
      text: BusinessTypesDisplayNames[BusinessTypes.NonProfit]
    },
    {
      value: BusinessTypes.NotaryPublic,
      text: BusinessTypesDisplayNames[BusinessTypes.NotaryPublic]
    },
    {
      value: BusinessTypes.OnlineBusiness,
      text: BusinessTypesDisplayNames[BusinessTypes.OnlineBusiness]
    },
    {
      value: BusinessTypes.PrintingServices,
      text: BusinessTypesDisplayNames[BusinessTypes.PrintingServices]
    },
    {
      value: BusinessTypes.RecordBusiness,
      text: BusinessTypesDisplayNames[BusinessTypes.RecordBusiness]
    },
    {
      value: BusinessTypes.RetailSales,
      text: BusinessTypesDisplayNames[BusinessTypes.RetailSales]
    },
    {
      value: BusinessTypes.TechnologyServices,
      text: BusinessTypesDisplayNames[BusinessTypes.TechnologyServices]
    },
    {
      value: BusinessTypes.Telemarketing,
      text: BusinessTypesDisplayNames[BusinessTypes.Telemarketing]
    },
    {
      value: BusinessTypes.Telecommunications,
      text: BusinessTypesDisplayNames[BusinessTypes.Telecommunications]
    },
    {
      value: BusinessTypes.DataProcessingAndHosting,
      text: BusinessTypesDisplayNames[BusinessTypes.DataProcessingAndHosting]
    },
    {
      value: BusinessTypes.TravelServices,
      text: BusinessTypesDisplayNames[BusinessTypes.TravelServices]
    },
    {
      value: BusinessTypes.VideoProduction,
      text: BusinessTypesDisplayNames[BusinessTypes.VideoProduction]
    },
    {
      value: BusinessTypes.ReligiousOrganizations,
      text: BusinessTypesDisplayNames[BusinessTypes.ReligiousOrganizations]
    },
    {
      value: BusinessTypes.OtherBusiness,
      text: BusinessTypesDisplayNames[BusinessTypes.OtherBusiness]
    }
  ],
  [BusinessTypeIndustries.Technical]: [
    { value: BusinessTypes.LegalServices, text: BusinessTypesDisplayNames[BusinessTypes.LegalServices] },
    { value: BusinessTypes.AccountingServices, text: BusinessTypesDisplayNames[BusinessTypes.AccountingServices] },
    { value: BusinessTypes.BookkeepingServices, text: BusinessTypesDisplayNames[BusinessTypes.BookkeepingServices] },
    {
      value: BusinessTypes.ManagementConsultingServices,
      text: BusinessTypesDisplayNames[BusinessTypes.ManagementConsultingServices]
    },
    {
      value: BusinessTypes.ScientificConsultingServices,
      text: BusinessTypesDisplayNames[BusinessTypes.ScientificConsultingServices]
    },
    {
      value: BusinessTypes.TechnicalConsultingServices,
      text: BusinessTypesDisplayNames[BusinessTypes.TechnicalConsultingServices]
    },
    {
      value: BusinessTypes.ScientificResearchDevelopment,
      text: BusinessTypesDisplayNames[BusinessTypes.ScientificResearchDevelopment]
    },
    { value: BusinessTypes.CompanyManagement, text: BusinessTypesDisplayNames[BusinessTypes.CompanyManagement] },
    {
      value: BusinessTypes.SpecializedDesignServices,
      text: BusinessTypesDisplayNames[BusinessTypes.SpecializedDesignServices]
    },
    {
      value: BusinessTypes.ComputerSystemsDesign,
      text: BusinessTypesDisplayNames[BusinessTypes.ComputerSystemsDesign]
    },
    { value: BusinessTypes.OtherTechnical, text: BusinessTypesDisplayNames[BusinessTypes.OtherTechnical] }
  ],
  [BusinessTypeIndustries.Education]: [
    { value: BusinessTypes.ChildCare, text: BusinessTypesDisplayNames[BusinessTypes.ChildCare] },
    {
      value: BusinessTypes.CollegesAndUniversities,
      text: BusinessTypesDisplayNames[BusinessTypes.CollegesAndUniversities]
    },
    { value: BusinessTypes.JuniorColleges, text: BusinessTypesDisplayNames[BusinessTypes.JuniorColleges] },
    {
      values: BusinessTypes.ElementaryAndSecondaryEducation,
      text: BusinessTypesDisplayNames[BusinessTypes.ElementaryAndSecondaryEducation]
    },
    { value: BusinessTypes.BusinessSchools, text: BusinessTypesDisplayNames[BusinessTypes.BusinessSchools] },
    { value: BusinessTypes.ComputerTraining, text: BusinessTypesDisplayNames[BusinessTypes.ComputerTraining] },
    {
      value: BusinessTypes.TechnicalAndTradeSchools,
      text: BusinessTypesDisplayNames[BusinessTypes.TechnicalAndTradeSchools]
    },
    { value: BusinessTypes.Tutoring, text: BusinessTypesDisplayNames[BusinessTypes.Tutoring] },
    { value: BusinessTypes.VocationalSchool, text: BusinessTypesDisplayNames[BusinessTypes.VocationalSchool] },
    { value: BusinessTypes.CosmetologySchool, text: BusinessTypesDisplayNames[BusinessTypes.CosmetologySchool] },
    { value: BusinessTypes.PrivateSchools, text: BusinessTypesDisplayNames[BusinessTypes.PrivateSchools] },
    { value: BusinessTypes.OtherEducation, text: BusinessTypesDisplayNames[BusinessTypes.OtherEducation] }
  ],
  [BusinessTypeIndustries.Healthcare]: [
    { value: BusinessTypes.AmbulatoryServices, text: BusinessTypesDisplayNames[BusinessTypes.AmbulatoryServices] },
    {
      value: BusinessTypes.EmergencyMedicalServices,
      text: BusinessTypesDisplayNames[BusinessTypes.EmergencyMedicalServices]
    },
    {
      value: BusinessTypes.EmergencyMedicalTransportation,
      text: BusinessTypesDisplayNames[BusinessTypes.EmergencyMedicalTransportation]
    },
    {
      value: BusinessTypes.NonEmergencyMedicalTransportation,
      text: BusinessTypesDisplayNames[BusinessTypes.NonEmergencyMedicalTransportation]
    },
    { value: BusinessTypes.Hospitals, text: BusinessTypesDisplayNames[BusinessTypes.Hospitals] },
    { value: BusinessTypes.NursingFacilities, text: BusinessTypesDisplayNames[BusinessTypes.NursingFacilities] },
    { value: BusinessTypes.HomeHealthServices, text: BusinessTypesDisplayNames[BusinessTypes.HomeHealthServices] },
    { value: BusinessTypes.SocialAssistance, text: BusinessTypesDisplayNames[BusinessTypes.SocialAssistance] },
    { value: BusinessTypes.MentalHealthServices, text: BusinessTypesDisplayNames[BusinessTypes.MentalHealthServices] },
    { value: BusinessTypes.Acupuncturist, text: BusinessTypesDisplayNames[BusinessTypes.Acupuncturist] },
    { value: BusinessTypes.AthleticTraining, text: BusinessTypesDisplayNames[BusinessTypes.AthleticTraining] },
    { value: BusinessTypes.YouthServices, text: BusinessTypesDisplayNames[BusinessTypes.YouthServices] },
    { value: BusinessTypes.Chiropractic, text: BusinessTypesDisplayNames[BusinessTypes.Chiropractic] },
    { value: BusinessTypes.Dentistry, text: BusinessTypesDisplayNames[BusinessTypes.Dentistry] },
    { value: BusinessTypes.Electrolysis, text: BusinessTypesDisplayNames[BusinessTypes.Electrolysis] },
    { value: BusinessTypes.Embalmer, text: BusinessTypesDisplayNames[BusinessTypes.Embalmer] },
    { value: BusinessTypes.HearingAidDealers, text: BusinessTypesDisplayNames[BusinessTypes.HearingAidDealers] },
    { value: BusinessTypes.MassageTherapy, text: BusinessTypesDisplayNames[BusinessTypes.MassageTherapy] },
    { value: BusinessTypes.MedicalOffice, text: BusinessTypesDisplayNames[BusinessTypes.MedicalOffice] },
    { value: BusinessTypes.Optometry, text: BusinessTypesDisplayNames[BusinessTypes.Optometry] },
    { value: BusinessTypes.Pharmacy, text: BusinessTypesDisplayNames[BusinessTypes.Pharmacy] },
    { value: BusinessTypes.PhysicalTherapy, text: BusinessTypesDisplayNames[BusinessTypes.PhysicalTherapy] },
    { value: BusinessTypes.PhysiciansOffice, text: BusinessTypesDisplayNames[BusinessTypes.PhysiciansOffice] },
    { value: BusinessTypes.Radiology, text: BusinessTypesDisplayNames[BusinessTypes.Radiology] },
    { value: BusinessTypes.OccupationalTherapy, text: BusinessTypesDisplayNames[BusinessTypes.OccupationalTherapy] },
    {
      value: BusinessTypes.SubstanceAbuseServices,
      text: BusinessTypesDisplayNames[BusinessTypes.SubstanceAbuseServices]
    },
    { value: BusinessTypes.VeterinaryMedicine, text: BusinessTypesDisplayNames[BusinessTypes.VeterinaryMedicine] },
    {
      value: BusinessTypes.VocationalRehabilitation,
      text: BusinessTypesDisplayNames[BusinessTypes.VocationalRehabilitation]
    },
    {
      value: BusinessTypes.WholesaleDrugDistribution,
      text: BusinessTypesDisplayNames[BusinessTypes.WholesaleDrugDistribution]
    },
    { value: BusinessTypes.MedicalSupplies, text: BusinessTypesDisplayNames[BusinessTypes.MedicalSupplies] },
    { value: BusinessTypes.HealthProfessionals, text: BusinessTypesDisplayNames[BusinessTypes.HealthProfessionals] },
    { value: BusinessTypes.OtherHealthcare, text: BusinessTypesDisplayNames[BusinessTypes.OtherHealthcare] }
  ],
  [BusinessTypeIndustries.Finance]: [
    {
      value: BusinessTypes.Auditing,
      text: BusinessTypesDisplayNames[BusinessTypes.Auditing]
    },
    {
      value: BusinessTypes.BankCreditUnion,
      text: BusinessTypesDisplayNames[BusinessTypes.BankCreditUnion]
    },
    {
      value: BusinessTypes.CashAdvances,
      text: BusinessTypesDisplayNames[BusinessTypes.CashAdvances]
    },
    {
      value: BusinessTypes.CollectionAgency,
      text: BusinessTypesDisplayNames[BusinessTypes.CollectionAgency]
    },
    {
      value: BusinessTypes.InsuranceCarriers,
      text: BusinessTypesDisplayNames[BusinessTypes.InsuranceCarriers]
    },
    {
      value: BusinessTypes.CreditIntermediation,
      text: BusinessTypesDisplayNames[BusinessTypes.CreditIntermediation]
    },
    {
      value: BusinessTypes.FinancialVehicles,
      text: BusinessTypesDisplayNames[BusinessTypes.FinancialVehicles]
    },
    {
      value: BusinessTypes.FinancialInvestments,
      text: BusinessTypesDisplayNames[BusinessTypes.FinancialInvestments]
    },
    {
      value: BusinessTypes.Investor,
      text: BusinessTypesDisplayNames[BusinessTypes.Investor]
    },
    {
      value: BusinessTypes.PawnBrokers,
      text: BusinessTypesDisplayNames[BusinessTypes.PawnBrokers]
    },
    {
      value: BusinessTypes.OtherFinance,
      text: BusinessTypesDisplayNames[BusinessTypes.OtherFinance]
    }
  ],
  [BusinessTypeIndustries.Safety]: [
    { value: BusinessTypes.BailBonds, text: BusinessTypesDisplayNames[BusinessTypes.BailBonds] },
    { value: BusinessTypes.DrugScreening, text: 'Drug Screening' },
    { value: BusinessTypes.Locksmith, text: 'Locksmith' },
    { value: BusinessTypes.PrivateInvestigator, text: 'Private Investigator' },
    { value: BusinessTypes.SecurityGaurd, text: 'Security Guard' },
    { value: BusinessTypes.SecuritySystemServices, text: 'Security System Services' },
    { value: BusinessTypes.DefenseAerospace, text: 'Defense Aerospace' },
    { value: BusinessTypes.DefenseElectronics, text: 'Defense Electronics' },
    { value: BusinessTypes.OtherSafety, text: 'Other (Safety & Security Services)' }
  ],
  [BusinessTypeIndustries.Transportation]: [
    { value: BusinessTypes.AviationTransportation, text: 'Aviation & Air Transportation' },
    { value: BusinessTypes.BoatServices, text: 'Boat Services' },
    { value: BusinessTypes.SeaTransport, text: 'Sea Transport' },
    { value: BusinessTypes.WaterTransportation, text: 'Water Transportation' },
    { value: BusinessTypes.GroundPassengerTransportation, text: 'Transit & Ground Passenger Transportation' },
    { value: BusinessTypes.PipelineTransportation, text: 'Pipeline Transportation' },
    { value: BusinessTypes.LimousineServices, text: 'Limousine Services' },
    { value: BusinessTypes.TaxiServices, text: 'Taxi Services' },
    { value: BusinessTypes.TowingServices, text: 'Towing Services' },
    { value: BusinessTypes.TruckTransportationFuel, text: 'Truck Transportation (Fuel)' },
    { value: BusinessTypes.TruckTransportation, text: 'Truck Transportation (Non-Fuel)' },
    { value: BusinessTypes.RailTransportation, text: 'Rail Transportation' },
    { value: BusinessTypes.SightseeingTransportation, text: 'Sightseeing Transportation' },
    { value: BusinessTypes.Couriers, text: 'Couriers' },
    { value: BusinessTypes.Storage, text: 'Storage' },
    { value: BusinessTypes.OtherTransportation, text: 'Other (Transportation)' }
  ],
  [BusinessTypeIndustries.MotorVehicle]: [
    { value: BusinessTypes.AutoPartSales, text: 'Auto Part Sales' },
    { value: BusinessTypes.CarWash, text: 'Car Wash & Detailing' },
    { value: BusinessTypes.MotorVehicleRental, text: 'Motor Vehicle Rental' },
    { value: BusinessTypes.MotorVehicleRepair, text: 'Motor Vehicle Repair' },
    { value: BusinessTypes.NewMotorVehicleSales, text: 'New Motor Vehicle Sales' },
    { value: BusinessTypes.RecreationalVehicleSales, text: 'Recreational Vehicle Sales' },
    { value: BusinessTypes.UsedMotorVehicleSales, text: 'Used Motor Vehicle Sales' },
    { value: BusinessTypes.OtherMotorVehicle, text: 'Other (Motor Vehicle)' }
  ],
  [BusinessTypeIndustries.Manufacturing]: [
    { value: BusinessTypes.FoodManufacturing, text: 'Food Manufacturing' },
    { value: BusinessTypes.BeverageManufacturing, text: 'Beverage Manufacturing' },
    { value: BusinessTypes.TobaccaoManufacturing, text: 'Tobacco Manufacturing' },
    { value: BusinessTypes.TextileMills, text: 'Textile Mills' },
    { value: BusinessTypes.TextileProductMills, text: 'Textile Product Mills' },
    { value: BusinessTypes.ApparelManufacturing, text: 'Apparel Manufacturing' },
    { value: BusinessTypes.LeatherManufacturing, text: 'Leather & Allied Product Manufacturing' },
    { value: BusinessTypes.WoodProductManufacturing, text: 'Wood Product Manufacturing' },
    { value: BusinessTypes.PaperManufacturing, text: 'Paper Manufacturing' },
    { value: BusinessTypes.CoalProductsManufacturing, text: 'Petroleum & Coal Products Manufacturing' },
    { value: BusinessTypes.ChemicalManufacturing, text: 'Chemical Manufacturing' },
    { value: BusinessTypes.PlasticsManufacturing, text: 'Plastics & Rubber Manufacturing' },
    { value: BusinessTypes.NonmetallicMineralProductsManufacturing, text: 'Nonmetallic Mineral Products Manufacturing' },
    { value: BusinessTypes.PrimaryMetalManufacturing, text: 'Primary Metal Manufacturing' },
    { value: BusinessTypes.FabricatedMetalManufacturing, text: 'Fabricated Metal Manufacturing' },
    { value: BusinessTypes.MachineryManufacturing, text: 'Machinery Manufacturing' },
    { value: BusinessTypes.ElectronicProductManufacturing, text: 'Computer & Electronic Product Manufacturing' },
    { value: BusinessTypes.ElectricalManufacturing, text: 'Electrical Equipment, Appliances, & Component Manufacturing' },
    { value: BusinessTypes.TransportationManufacturing, text: 'Transportation Manufacturing' },
    { value: BusinessTypes.FurnitureManufacturing, text: 'Furniture & Related Product Manufacturing' },
    { value: BusinessTypes.MiscManufacturing, text: 'Miscellaneous Manufacturing' }
  ],
  [BusinessTypeIndustries.RealEstate]: [
    {
      value: BusinessTypes.PropertyManagement,
      text: BusinessTypesDisplayNames[BusinessTypes.PropertyManagement]
    },
    {
      value: BusinessTypes.RealEstateBrokerAgent,
      text: BusinessTypesDisplayNames[BusinessTypes.RealEstateBrokerAgent]
    },
    {
      value: BusinessTypes.Warehouse,
      text: BusinessTypesDisplayNames[BusinessTypes.Warehouse]
    },
    {
      value: BusinessTypes.AutomotiveEquipmentRental,
      text: BusinessTypesDisplayNames[BusinessTypes.AutomotiveEquipmentRental]
    },
    {
      value: BusinessTypes.ConsumerGoodsRental,
      text: BusinessTypesDisplayNames[BusinessTypes.ConsumerGoodsRental]
    },
    {
      value: BusinessTypes.GeneralRentalCenters,
      text: BusinessTypesDisplayNames[BusinessTypes.GeneralRentalCenters]
    },
    {
      value: BusinessTypes.CommercialIndustrialMachineryRental,
      text: BusinessTypesDisplayNames[BusinessTypes.CommercialIndustrialMachineryRental]
    },
    {
      value: BusinessTypes.Leasing,
      text: BusinessTypesDisplayNames[BusinessTypes.Leasing]
    },
    {
      value: BusinessTypes.OtherRealEstate,
      text: BusinessTypesDisplayNames[BusinessTypes.OtherRealEstate]
    }
  ],
  [BusinessTypeIndustries.Wholesale]: [
    { value: BusinessTypes.WholesaleDurableGoods, text: BusinessTypesDisplayNames[BusinessTypes.WholesaleDurableGoods] },
    { value: BusinessTypes.WholesaleNonDurableGoods, text: BusinessTypesDisplayNames[BusinessTypes.WholesaleNonDurableGoods] }
  ],
  [BusinessTypeIndustries.Hospitality]: [
    { value: BusinessTypes.LodgingTourism, text: BusinessTypesDisplayNames[BusinessTypes.LodgingTourism] },
    { value: BusinessTypes.AlcoholTobaccoSales, text: BusinessTypesDisplayNames[BusinessTypes.AlcoholTobaccoSales] },
    { value: BusinessTypes.AlcoholicBeverageManufacturing, text: BusinessTypesDisplayNames[BusinessTypes.AlcoholicBeverageManufacturing] },
    { value: BusinessTypes.TobaccoProductManufacturing, text: BusinessTypesDisplayNames[BusinessTypes.TobaccoProductManufacturing] },
    { value: BusinessTypes.Bakery, text: BusinessTypesDisplayNames[BusinessTypes.Bakery] },
    { value: BusinessTypes.Catering, text: BusinessTypesDisplayNames[BusinessTypes.Catering] },
    { value: BusinessTypes.FoodBeverageManufacturing, text: BusinessTypesDisplayNames[BusinessTypes.FoodBeverageManufacturing] },
    { value: BusinessTypes.GasStationStore, text: BusinessTypesDisplayNames[BusinessTypes.GasStationStore] },
    { value: BusinessTypes.GroceryConvenienceStore, text: BusinessTypesDisplayNames[BusinessTypes.GroceryConvenienceStore] },
    { value: BusinessTypes.TruckStop, text: BusinessTypesDisplayNames[BusinessTypes.TruckStop] },
    { value: BusinessTypes.VendingMachine, text: BusinessTypesDisplayNames[BusinessTypes.VendingMachine] },
    { value: BusinessTypes.MobileFoodService, text: BusinessTypesDisplayNames[BusinessTypes.MobileFoodService] },
    { value: BusinessTypes.BarRestuarant, text: BusinessTypesDisplayNames[BusinessTypes.BarRestuarant] },
    { value: BusinessTypes.SpecialFoodServices, text: BusinessTypesDisplayNames[BusinessTypes.SpecialFoodServices] },
    { value: BusinessTypes.Produce, text: BusinessTypesDisplayNames[BusinessTypes.Produce] },
    { value: BusinessTypes.Meat, text: BusinessTypesDisplayNames[BusinessTypes.Meat] },
    { value: BusinessTypes.Seafood, text: BusinessTypesDisplayNames[BusinessTypes.Seafood] },
    { value: BusinessTypes.Casino, text: BusinessTypesDisplayNames[BusinessTypes.Casino] },
    { value: BusinessTypes.HotelsMotels, text: BusinessTypesDisplayNames[BusinessTypes.HotelsMotels] },
    { value: BusinessTypes.TravelerAccommodations, text: BusinessTypesDisplayNames[BusinessTypes.TravelerAccommodations] },
    { value: BusinessTypes.RVParks, text: BusinessTypesDisplayNames[BusinessTypes.RVParks] },
    { value: BusinessTypes.BoardingHouses, text: BusinessTypesDisplayNames[BusinessTypes.BoardingHouses] },
    { value: BusinessTypes.ShortTermRental, text: BusinessTypesDisplayNames[BusinessTypes.ShortTermRental] },
    { value: BusinessTypes.OtherHospitality, text: BusinessTypesDisplayNames[BusinessTypes.OtherHospitality] }
  ]
};
